import type { Point } from "../types";
import type { Tool } from "./Tool";

/** Hand tool: dragging pans. The gesture hook owns the actual pan (it is
 *  shared with space-drag and the middle button), so this only sets the
 *  cursor and tells the hook a press should pan. */
export const createPanTool = (): Tool => ({
  kind: "pan",
  cursor: "grab",
  onPointerDown: () => {},
  onPointerMove: () => {},
  onPointerUp: () => {},
  cancel: () => {}
});

export const isPanGestureStart = (
  toolKind: string,
  event: PointerEvent,
  isSpaceDown: boolean
): boolean =>
  event.button === 1 ||
  isSpaceDown ||
  (toolKind === "pan" && event.button === 0);

export const panBy = (viewport: Point & { scale: number }, delta: Point) => ({
  x: viewport.x + delta.x,
  y: viewport.y + delta.y,
  scale: viewport.scale
});
